"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nextSubscriptionDiscountAfterConsume = exports.consumedSubscriptionDiscountStub = exports.subscriptionDiscountStampFromCompany = exports.resolvedDiscountPercentOff = exports.resolveSubscriptionDiscount = exports.subscriptionHasAuthoritativeDiscount = exports.legacyDiscountToSubscriptionDiscount = exports.hasActiveSubscriptionDiscount = exports.normalizeDiscountDuration = void 0;
function normalizeDiscountDuration(duration) {
    const d = String(duration || "").trim().toLowerCase();
    if (d === "once" || d === "repeating" || d === "forever")
        return d;
    return "forever";
}
exports.normalizeDiscountDuration = normalizeDiscountDuration;
function hasActiveSubscriptionDiscount(discount) {
    return !!discount && Number(discount.percentOff) > 0;
}
exports.hasActiveSubscriptionDiscount = hasActiveSubscriptionDiscount;
function legacyDiscountToSubscriptionDiscount(fields) {
    var _a;
    const percentOff = Number(fields === null || fields === void 0 ? void 0 : fields.discountPercentOff);
    if (!Number.isFinite(percentOff) || percentOff <= 0)
        return null;
    const duration = normalizeDiscountDuration(fields === null || fields === void 0 ? void 0 : fields.discountDuration);
    return {
        percentOff,
        duration,
        durationInMonths: duration === "repeating" ? (_a = fields === null || fields === void 0 ? void 0 : fields.discountDurationInMonths) !== null && _a !== void 0 ? _a : null : null,
    };
}
exports.legacyDiscountToSubscriptionDiscount = legacyDiscountToSubscriptionDiscount;
function subscriptionHasAuthoritativeDiscount(sub) {
    return (sub === null || sub === void 0 ? void 0 : sub.subscriptionDiscount) != null && typeof sub.subscriptionDiscount === "object";
}
exports.subscriptionHasAuthoritativeDiscount = subscriptionHasAuthoritativeDiscount;
function resolveSubscriptionDiscount(params) {
    if (subscriptionHasAuthoritativeDiscount(params.subscription)) {
        const discount = params.subscription.subscriptionDiscount;
        return hasActiveSubscriptionDiscount(discount) ? discount : null;
    }
    return null;
}
exports.resolveSubscriptionDiscount = resolveSubscriptionDiscount;
function resolvedDiscountPercentOff(params) {
    const discount = resolveSubscriptionDiscount(params);
    return hasActiveSubscriptionDiscount(discount) ? discount.percentOff : null;
}
exports.resolvedDiscountPercentOff = resolvedDiscountPercentOff;
/** Legacy migration helper. Runtime billing must read CompanySubscription.subscriptionDiscount. */
function subscriptionDiscountStampFromCompany(company) {
    return { subscriptionDiscount: legacyDiscountToSubscriptionDiscount(company) };
}
exports.subscriptionDiscountStampFromCompany = subscriptionDiscountStampFromCompany;
/** after once / last repeating period: keep an object so we do not fall back to company. */
function consumedSubscriptionDiscountStub(previous) {
    var _a;
    return {
        percentOff: 0,
        duration: (_a = previous === null || previous === void 0 ? void 0 : previous.duration) !== null && _a !== void 0 ? _a : "once",
        durationInMonths: null,
    };
}
exports.consumedSubscriptionDiscountStub = consumedSubscriptionDiscountStub;
function nextSubscriptionDiscountAfterConsume(current) {
    const duration = normalizeDiscountDuration(current.duration);
    if (duration === "forever") {
        return { next: current, action: "forever_noop" };
    }
    if (duration === "once") {
        return { next: consumedSubscriptionDiscountStub(current), action: "cleared_once" };
    }
    const monthsLeft = Number(current.durationInMonths);
    if (!Number.isFinite(monthsLeft) || monthsLeft <= 1) {
        return { next: consumedSubscriptionDiscountStub(current), action: "cleared_repeating" };
    }
    return {
        next: {
            percentOff: current.percentOff,
            duration: "repeating",
            durationInMonths: monthsLeft - 1,
        },
        action: "decremented_repeating",
    };
}
exports.nextSubscriptionDiscountAfterConsume = nextSubscriptionDiscountAfterConsume;
